// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__W5KCt","info":"Note_info__EoNhZ","note":"Note_note__35BnT","actions":"Note_actions__sf7Hd"};